import { render } from "./BtnFixedItem.vue?vue&type=template&id=5ea5c4c4"
import script from "./BtnFixedItem.vue?vue&type=script&lang=js"
export * from "./BtnFixedItem.vue?vue&type=script&lang=js"

import "./BtnFixedItem.vue?vue&type=style&index=0&id=5ea5c4c4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/BtnFixedItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ea5c4c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ea5c4c4', __exports__)) {
    api.reload('5ea5c4c4', __exports__)
  }
  
  module.hot.accept("./BtnFixedItem.vue?vue&type=template&id=5ea5c4c4", () => {
    api.rerender('5ea5c4c4', render)
  })

}


export default __exports__